import React, { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
class RightComponentOrderRequest extends Component {
  state = {
    tip: 0,
  };
  render() {
    const { phase, cart_data } = this.props;
    return (
      //   <React.Fragment>
      <Container fluid style={{ backgroundColor: "#ffffff" }}>
        <h6>
          <b>Customer Order Details</b>
        </h6>
        {!phase > 3 && (
          <div align="right">
            <span
              onClick={() => {
                this.setState({ open: true });
              }}
              style={{ color: "#EE3A23", cursor: "pointer" }}
            >
              Edit
            </span>
          </div>
        )}
        <div style={{ paddingTop: "3%" }}>
          <span className="badge badge-warning">Take Away</span>&nbsp;
        </div>
        <div style={{ marginTop: "3%" }} className="icons-for-border-black">
          <img
            src={require("../../../../assets/images/superadmin/ordericon/1-03.svg")}
            width="20px"
            heigth="20px"
          />{" "}
          &nbsp; {this.props.user_details.first_name} &nbsp;{" "}
          {this.props.user_details.last_name}
          <br />
          <img
            src={require("../../../../assets/images/superadmin/ordericon/1-02.svg")}
            width="20px"
            heigth="20px"
          />{" "}
          &nbsp; +91 9999999999
          <br />
          <img
            src={require("../../../../assets/images/superadmin/ordericon/1-01.svg")}
            width="20px"
            heigth="20px"
          />{" "}
          &nbsp; 40-50 mins <br />
          &nbsp;{" "}
          <span
            style={{ fontSize: ".85rem", marginLeft: "20px", color: "#757575" }}
          >
            Estimated PrepTime
          </span>
        </div>
        <hr />
        <Row>
          <Col sm={3}>
            <img
              src={require("../../../../assets/images/superadmin/ordericon/car.svg")}
              width="100%"
            />{" "}
          </Col>
          <Col sm={9}>
            <b>GJ 01 1245</b>
            <p style={{ color: "#747474" }}>Volvo s90 | Silver</p>
          </Col>
        </Row>
        <hr />
        {(phase === 1 || phase === 2) && <StopWatch />}
        <div style={{ paddingTop: "5%" }}>
          <h6>Order Summary</h6>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td>
                  <b>Sub Total</b>
                </td>
                <td>
                  <b>₹450</b>
                </td>
              </tr>
              <tr>
                <td>Convenience Fee (10%)</td>
                <td>₹20</td>
              </tr>
              <tr>
                <td>GST (10%)</td>
                <td>₹20</td>
              </tr>
              <tr>
                <td>Bag & Packing Fee</td>
                <td>₹5</td>
              </tr>
              <tr>
                <td>Discount</td>
                <td>
                  <span style={{ color: "#EE3A23" }}>-</span>₹50
                </td>
              </tr>

              <tr
                style={{
                  backgroundColor: "#F8F8F8",
                }}
              >
                <td style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                  <b>Paid</b>
                </td>
                <td style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                  <b>₹400.00</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
      //   </React.Fragment>
    );
  }
}

class StopWatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hours: 0,
      minutes: 45,
      seconds: 52,
    };
  }

  componentDidMount() {
    setInterval(() => {
      if (
        this.state.seconds === 0 &&
        this.state.minutes === 0 &&
        this.state.hours !== 0
      ) {
        this.setState({
          seconds: 59,
          minutes: 59,
          hours: this.state.hours - 1,
        });
      } else if (this.state.seconds === 0) {
        this.setState({ seconds: 59, minutes: this.state.minutes - 1 });
      } else {
        this.setState({ seconds: this.state.seconds - 1 });
      }
    }, 1000);
  }

  render() {
    const { hours, minutes, seconds } = this.state;
    return (
      <React.Fragment>
        <Container fluid className="p-0">
          <Row className="p-0" style={{ height: "91px" }}>
            <Col xs={8} style={{ backgroundColor: "#F5F5F5" }}>
              <div style={{ padding: "15px" }}>
                <b>Countdown</b>
                <br />
                <b style={{ fontSize: "1.25rem" }}>
                  {hours.toString().length === 1 ? `0${hours}` : hours}{" "}
                </b>
                <span style={{ color: "#5D5D5D" }}>H</span>&nbsp;:&nbsp;
                <b style={{ fontSize: "1.25rem" }}>
                  {minutes.toString().length === 1 ? `0${minutes}` : minutes}{" "}
                </b>
                <span style={{ color: "#5D5D5D" }}>M</span>&nbsp;:&nbsp;
                <b style={{ fontSize: "1.25rem" }}>
                  {seconds.toString().length === 1 ? `0${seconds}` : seconds}{" "}
                </b>
                <span style={{ color: "#5D5D5D" }}>S</span>
              </div>
            </Col>
            <Col xs={4} style={{ backgroundColor: "#FCB614" }}>
              <img
                src={require("../../../../assets/images/superadmin/ordericon/Icons_25 nov-07 (2).svg")}
                // width="20px"
                // heigth="20px"
              />{" "}
            </Col>
          </Row>
          <hr />
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  cart_data: state.vendorOrdering.vendor_cart_data,
});

export default withRouter(
  connect(mapStateToProps, null)(RightComponentOrderRequest)
);

// export default RightComponentOrderRequest;
